import { createTLStore, defaultShapeUtils, getSnapshot, loadSnapshot, throttle, TLStoreWithStatus } from "tldraw"
import { useEffect, useState } from "react"
import { RulerShapeUtil } from "../../modules/online-lesson/tldraw/shapes/ruler"
import { ProtractorShapeUtil } from "../../modules/online-lesson/tldraw/shapes/protractor"
import { SetSquareShapeUtil } from "../../modules/online-lesson/tldraw/shapes/set-square"
import { SetSquare3060ShapeUtil } from "../../modules/online-lesson/tldraw/shapes/set-square-30-60"


const STORAGE_KEY = "tldraw_session";

export function useLocalStore(): TLStoreWithStatus {
  const [store] = useState(() => createTLStore({
    shapeUtils: [
      ...defaultShapeUtils,
      RulerShapeUtil, ProtractorShapeUtil, SetSquareShapeUtil, SetSquare3060ShapeUtil
    ]
  }));
  const [storeWithStatus, setStoreWithStatus] = useState<TLStoreWithStatus>({
    status: "loading",
  });

  useEffect(() => {
    setStoreWithStatus({ status: "loading" });

    // 1. Attempt to restore a previously saved snapshot from sessionStorage
    const persistedSnapshot = sessionStorage.getItem(STORAGE_KEY);

    if (persistedSnapshot) {
      try {
        const snapshot = JSON.parse(persistedSnapshot);
        loadSnapshot(store, snapshot);
      } catch (e) {
        console.warn("[tldraw] Failed to restore session snapshot:", e);
        sessionStorage.removeItem(STORAGE_KEY);
      }
    }

    setStoreWithStatus({ status: "synced-local", store });

    // 2. Persist to sessionStorage on every change (throttled to 100 ms)
    const save = throttle(() => {
      try {
        const snapshot = getSnapshot(store);
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot));
      } catch (e) {
        console.warn("[tldraw] Failed to save session snapshot:", e);
      }
    }, 100);

    const unsub = store.listen(save, {
      source: "user",  // only persist user-driven changes
      scope: "document",
    });

    return () => {
      save.cancel?.();
      unsub();
    };
  }, [store]);

  return storeWithStatus;
}
